import React from 'react';
import { Picker } from '../../../../components/ui';
import { GENDER_OPTIONS } from '../../../../components/GenderSelect';

const genderLabel = (gender) => GENDER_OPTIONS.find(o => o.value === gender && o.value)?.label;
const ageText = (g) => (g.age === undefined ? null : g.age !== null ? `Age ${g.age}` : 'No DOB');
const describe = (g) => [ageText(g), genderLabel(g.gender)].filter(Boolean).join(' · ');

// Pick one gymnast with the shared Picker. gymnasts: [{ id, firstName,
// lastName, age, gender }]. age null shows "No DOB"; leave age out to show
// nothing (for staff who don't see dates of birth). excludeId leaves one out
// (the other half of a synchro pair). hideLabel keeps the label for screen
// readers only, for pickers that sit in a filter row.
export default function GymnastPicker({ id, label, gymnasts, value, onChange, excludeId, hideLabel = false, placeholder = 'Search by name…' }) {
  const items = gymnasts
    .filter(g => g.id !== excludeId)
    .map(g => ({ id: g.id, label: `${g.firstName} ${g.lastName}`, detail: describe(g) || undefined }));
  const selected = value ? gymnasts.find(g => g.id === value) : null;
  return (
    <div className="gymnast-picker">
      {!hideLabel && <label className="bk-label" htmlFor={id}>{label}</label>}
      <Picker
        id={id}
        label={label}
        items={items}
        value={value || ''}
        onChange={onChange}
        placeholder={placeholder}
        noneText="No gymnasts match."
      />
      {selected && describe(selected) && <p className="bk-small gymnast-picker__detail">{describe(selected)}</p>}
    </div>
  );
}
